import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/dashboard/calendar/calendar-custom.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/events/calendar/PublicEventsCalendar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.2.6_react@19.2.6__react@19.2.6/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.2.6_react@19.2.6__react@19.2.6/node_modules/next/dist/client/image-component.js");
